import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { ToggleService } from '@df/ui/toggle/toggle.service';
import { UiComponent } from '@df/ui/ui.component';
import { NPageHeader } from '../page-header.component';

@Component({
    selector: 'page-header-shop-submenu-content',
    templateUrl: 'page-header-shop-submenu-content.html',
    styleUrls: ['page-header-shop-submenu-content.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHeaderShopSubmenuContentComponent extends UiComponent implements OnInit {
    @Input()
    items?: NPageHeader.IShopSubmenuItem[];

    @Input()
    promobannerBlocks?: NPageHeader.IPromobarContentBlock[];

    @Input()
    promobannerBackround?: string;

    @Input()
    promobannerColor?: string;

    protected secondLevelItem: NPageHeader.IShopSubmenuItem | undefined = undefined;
    protected thirdLevelItem: NPageHeader.IShopSubmenuItem | undefined = undefined;

    protected toggleService = inject(ToggleService);
    private router = inject(Router);
    private blockOpenForAnimation = false;

    override ngOnInit(): void {
        super.ngOnInit();
        this.subscriptions.add(
            this.router.events.subscribe(e => {
                if (e instanceof NavigationStart) {
                    this.blockOpenForAnimation = true;
                    this.onMouseOut(0, 0);

                    this.timeoutService.setTimeout(() => {
                        this.blockOpenForAnimation = false;
                    }, 200);
                }
            })
        );
    }

    /**
     * Group id for toggle service
     */
    readonly toggleGroupId = NPageHeader.SHOP_SUBMENU_GROUP_ID;

    protected onMouseIn(index: number): void {
        if (!this.client.isCms && !this.blockOpenForAnimation) {
            this.toggleService.open([this.toggleGroupId, index]);
        }
    }
    protected onMouseOut(index: number, delay = 200): void {
        if (!this.client.isCms) {
            this.changeSecondLevelItem(undefined);
            this.changeThirdLevelItem(undefined);
            this.toggleService.close([this.toggleGroupId, index], { delay });
        }
    }

    protected changeSecondLevelItem(item: NPageHeader.IShopSubmenuItem | undefined): void {
        this.changeThirdLevelItem(undefined);
        this.secondLevelItem = item;
        this.detectChanges();
    }

    protected changeThirdLevelItem(item: NPageHeader.IShopSubmenuItem | undefined): void {
        this.thirdLevelItem = item;
        this.detectChanges();
    }

    protected get secondLevelOpened(): boolean {
        return !!(this.secondLevelItem?.submenus && this.secondLevelItem?.submenus?.length > 0);
    }

    protected get thirdLevelOpened(): boolean {
        return !!(this.thirdLevelItem?.submenus && this.thirdLevelItem?.submenus?.length > 0);
    }
}
